import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ICreateTaskState } from './types/CreateTask-interface'

const createTaskState = (state: RootState): ICreateTaskState => state.createTask

export const CreateTaskID = createSelector(
    [createTaskState],
    (state): string => state.CreateTaskID,
)
export const CreateTaskNumber = createSelector(
    [createTaskState],
    (state): string => state.CreateTaskNumber,
)
export const CreateTaskError = createSelector(
    [createTaskState],
    (state): string[] => state.errorCreateTask,
)
export const CreateTaskLastFetch = createSelector(
    [createTaskState],
    (state): null | number => state.lastFetchTime,
)
export const CreateTaskLoading = createSelector(
    [createTaskState],
    (state): boolean => state.isLoadingCreateTask,
)